/**
 * The consent scopes a company page reports as withheld — "N talents do not
 * share …" beside a number the server computed without them — and the plural
 * i18n key for each. A read's `withheld` carries the counts; the page words
 * them through this map.
 */
export const WITHHELD_SCOPES = [
  'checkup',
  'teleportal',
  'qultureup',
  'care',
  'passport_stamps',
] as const;

export type WithheldScope = (typeof WITHHELD_SCOPES)[number];

/** Pluralised with `{ count }` (`…_one` / `…_other` in every locale). */
export const WITHHELD_NOTICE_KEY = {
  checkup: 'business.consent.withheld.checkup',
  teleportal: 'business.consent.withheld.teleportal',
  qultureup: 'business.consent.withheld.qultureup',
  care: 'business.consent.withheld.care',
  passport_stamps: 'business.consent.withheld.passport_stamps',
} as const satisfies Record<WithheldScope, string>;
